import React from 'react';

import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import EditorialBand from '../../components/public/EditorialBand.component';
import EditorialHero from '../../components/public/EditorialHero.component';
import EditorialProcess from '../../components/public/EditorialProcess.component';
import OfferCard from '../../components/public/OfferCard.component';
import {
  FRUIT_BASKET_CONTACT_HINT,
  FRUIT_BASKET_HERO,
  FRUIT_BASKET_OFFERS,
} from '../../constants/fruit-basket-content.constants';
import Meta from '../../../utils/metaDescription';

const useStyles = makeStyles((theme) => ({
  sectionTitle: {
    fontFamily: 'Bitter, serif',
    fontWeight: 700,
    fontSize: 'clamp(1.5rem, 4vw, 2.1rem)',
    lineHeight: 1.2,
    marginBottom: '2rem',
    textAlign: 'center',
    color: theme.palette.client.primary.extraDark,
  },
  processTitle: {
    fontFamily: 'Bitter, serif',
    fontWeight: 700,
    fontSize: 'clamp(1.15rem, 3vw, 1.4rem)',
    lineHeight: 1.25,
    marginBottom: '1.25rem',
    color: theme.palette.client.primary.extraDark,
  },
  contactHint: {
    marginTop: '1.5rem',
    textAlign: 'center',
    fontSize: '0.95rem',
    color: '#4a4a4a',
  },
}));

const FruitBasketView: React.FC = () => {
  const classes = useStyles();

  return (
    <React.Fragment>
      <Meta page="corbeille" />

      <EditorialBand ground="cream" underFloatingNav>
        <EditorialHero title={FRUIT_BASKET_HERO.title} lead={FRUIT_BASKET_HERO.lead} />
      </EditorialBand>

      {/* Les deux formules côte à côte : le visiteur se reconnaît au volume dont il a besoin. */}
      <EditorialBand ground="plain">
        <Grid container spacing={3} alignItems="stretch">
          {FRUIT_BASKET_OFFERS.map((offer) => (
            <Grid item xs={12} md={6} key={offer.title}>
              <OfferCard offer={offer} />
            </Grid>
          ))}
        </Grid>

        <Typography className={classes.contactHint}>{FRUIT_BASKET_CONTACT_HINT}</Typography>
      </EditorialBand>

      <EditorialBand ground="tint">
        <Typography component="h2" className={classes.sectionTitle}>
          Comment ça se passe
        </Typography>

        <Grid container spacing={3} alignItems="flex-start">
          {FRUIT_BASKET_OFFERS.map((offer) => (
            <Grid item xs={12} md={6} key={offer.processTitle}>
              <Typography component="h3" className={classes.processTitle}>
                {offer.processTitle}
              </Typography>
              <EditorialProcess steps={offer.processSteps} />
            </Grid>
          ))}
        </Grid>
      </EditorialBand>
    </React.Fragment>
  );
};

export default FruitBasketView;
